import React, { useEffect } from "react";
import ModernNavbar from "../components/modern-navbar";
import ModernFooter from "../components/modern-footer";

const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="modern-landing">
      <ModernNavbar />

      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <h1>Privacy Policy</h1>
            <p>
              Your privacy is important to us. Learn how we protect your data.
            </p>
          </div>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="legal-content">
            <h3>Information We Collect</h3>
            <p>
              We collect information you provide directly to us, such as when
              you create an account or contact us for support.
            </p>

            <h3>How We Use Your Information</h3>
            <p>
              We use the information we collect to provide, maintain, and
              improve our services.
            </p>

            <h3>Information Sharing</h3>
            <p>
              We do not sell, trade, or otherwise transfer your personal
              information to third parties without your consent.
            </p>

            <h3>Data Security</h3>
            <p>
              We implement appropriate security measures to protect your
              personal information.
            </p>
          </div>
        </div>
      </section>

      <ModernFooter />
    </div>
  );
};

export default Privacy;
